import { Row, Col, Typography, Statistic } from 'antd';

const { Title } = Typography;

export function Trust() {
  const stats = [
    { value: '50M+', label: 'API Requests Managed' },
    { value: '100K+', label: 'Subscriptions Supported' },
    { value: '99.99%', label: 'Platform Availability' },
    { value: 'Multi-Tenant', label: 'Enterprise Architecture' },
  ];

  return (
    <section
      style={{
        padding: '64px 24px',
        backgroundColor: '#fafafa',
        borderBottom: '1px solid #f0f0f0',
      }}
    >
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <Title
            level={2}
            style={{ fontSize: '28px', color: '#1f1f1f', margin: 0 }}
          >
            Built for Modern SaaS Businesses
          </Title>
        </div>
        <Row gutter={[32, 32]} justify="center">
          {stats.map((stat) => (
            <Col xs={12} sm={12} md={6} key={stat.label}>
              <div style={{ textAlign: 'center' }}>
                <Statistic
                  value={stat.value}
                  styles={{
                    content: {
                      fontSize: 'clamp(28px, 4vw, 36px)',
                      fontWeight: 'bold',
                      color: '#1677ff',
                    },
                  }}
                />
                <div
                  style={{
                    fontSize: '14px',
                    color: '#8c8c8c',
                    marginTop: '8px',
                  }}
                >
                  {stat.label}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
}
